<template>
    <footer class="footer">
        <div class="container-fluid">
            <nav>
                <ul class="footer-menu">
                    <li>
                        <router-link :to="{path:'/panel/overview'}">Dashboard</router-link>
                    </li>
                </ul>
            </nav>
            <div class="copyright text-center">
                &copy; Coded with
                <i class="fa fa-heart heart"></i> by
                <a href="https://skillforce.pl" target="_blank">Skillforce</a>.
            </div>
        </div>
    </footer>
</template>
<script>
    export default {}

</script>
<style>

</style>
